import { render, staticRenderFns } from "./RepresentacaoConjuntoForm.vue?vue&type=template&id=ef8b957e&lang=html"
import script from "./RepresentacaoConjuntoForm.vue?vue&type=script&lang=js"
export * from "./RepresentacaoConjuntoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports